import {
  PAGE_SETTING,
  PIM_ATTENDANCE,
  PIM_EVA,
  PIM_NEW_RESIGN,
  PIM_PDREQ,
  PIM_RECRUI,
  PIM_TRAIN,
  MENU_HOME,
  PAGE_MYPROFILE,
  EMP_CHECK_LIST_NEW,
  PAGE_REPORT_NEW,
  PAGE_INCOME
} from '../../../router/routes'
import { ReactComponent as Dashboard } from '../../../assets/main_menu/icon_dsb.svg'
import { ReactComponent as Employee } from '../../../assets/main_menu/icon_emp.svg'
import { ReactComponent as Income } from '../../../assets/main_menu/icon_income.svg'
import { ReactComponent as Report } from '../../../assets/main_menu/icon_report.svg'
import { ReactComponent as Setting } from '../../../assets/main_menu/icon_setting.svg'
import { ReactComponent as MyProfile } from '../../../assets/main_menu/icon_my-profile.svg'
import { ReactComponent as Attendance } from '../../../images/icons-nav/Attendance.svg'
import { ReactComponent as Training } from '../../../images/icons-nav/Training.svg'
import { ReactComponent as Evaluation } from '../../../images/icons-nav/Evaluation.svg'
import { ReactComponent as Recruitment } from '../../../images/icons-nav/Recruitment.svg'
import { ReactComponent as PDRequest } from '../../../images/icons-nav/PD-Request.svg'
import { ReactComponent as EmpInfo } from '../../../images/icons-nav/Employee info.svg'
import fnSubMenu from './map-2-submenu'

export default function fnMapMenu(d) {
  // Checklist

  switch (d.id) {
    case 11:
      return {
        id: d.id,
        label: d.menu_name,
        link: EMP_CHECK_LIST_NEW,
        key: PIM_NEW_RESIGN.split('/')[1],
        icon: <Employee />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    case 12:
      return {
        id: d.id,
        label: d.menu_name,
        link: PIM_ATTENDANCE,
        key: PIM_ATTENDANCE.split('/')[1],
        icon: <Attendance />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    case 13:
      return {
        id: d.id,
        label: d.menu_name,
        link: PIM_TRAIN,
        key: PIM_TRAIN.split('/')[1],
        icon: <Training />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    case 14:
      return {
        id: d.id,
        label: d.menu_name,
        link: PIM_EVA,
        key: PIM_EVA.split('/')[1],
        icon: <Evaluation />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    case 15:
      return {
        id: d.id,
        label: d.menu_name,
        link: PIM_RECRUI,
        key: PIM_RECRUI.split('/')[1],
        icon: <Recruitment />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    case 16:
      return {
        id: d.id,
        label: d.menu_name,
        link: PIM_PDREQ,
        key: PIM_PDREQ.split('/')[1],
        icon: <PDRequest />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    case 10:
      return {
        id: d.id,
        label: d.menu_name,
        link: MENU_HOME,
        key: MENU_HOME.split('/')[1],
        icon: <Dashboard />,
        submenu: []
      }

    case 19:
      return {
        id: d.id,
        label: d.menu_name,
        link: PAGE_MYPROFILE,
        key: PAGE_MYPROFILE.split('/')[1],
        icon: <MyProfile size={20} />,
        submenu: [],
        isBeta: true
      }
    case 17:
      return {
        id: d.id,
        label: d.menu_name,
        key: PAGE_SETTING.split('/')[1],
        link: PAGE_SETTING,
        icon: <Setting size={20} />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }
    case 18:
      return {
        id: d.id,
        label: d.menu_name,
        link: PAGE_REPORT_NEW,
        key: PAGE_REPORT_NEW.split('/')[1],
        icon: <Report />,

        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }
    case 20:
      return {
        id: d.id,
        label: d.menu_name,
        link: PAGE_INCOME,
        key: PAGE_INCOME.split('/')[1],
        icon: <Income size={20} />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }

    default:
      return {
        id: d.id,
        label: d.menu_name,
        link: d.sub_menus.length > 0 ? '' : '/404',
        key: '/404'.split('/')[1],
        icon: <EmpInfo />,
        submenu:
          d.sub_menus.length > 0
            ? d.sub_menus
                .map((s, i) => {
                  return fnSubMenu(s)
                })
                .filter((item) => item)
            : []
      }
  }
}
